var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { defineMessages, injectIntl } from 'react-intl';
var messages = defineMessages({
    main_up: {
        id: "main.up",
        defaultMessage: "Up"
    },
    main_back: {
        id: "main.back",
        defaultMessage: "Back"
    },
    main_live_chat: {
        id: 'main.live_chat',
        defaultMessage: 'Live chat'
    }
});
var Navigator = /** @class */ (function (_super) {
    __extends(Navigator, _super);
    function Navigator() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onScrollTopClick = function (e) {
            e.preventDefault();
            window.scrollTo(0, 0);
        };
        _this.onChatClick = function () {
            window.jivo_api.open();
        };
        return _this;
    }
    Navigator.prototype.render = function () {
        return (_jsx("div", __assign({ className: 'navigator' }, { children: _jsxs("ul", __assign({ className: 'no_back' }, { children: [_jsx("li", __assign({ className: 'online-chat', onClick: this.onChatClick }, { children: _jsx("a", __assign({ href: '#', className: 'n_online-chat', onClick: this.onScrollTopClick }, { children: this.props.intl.formatMessage(messages.main_live_chat) })) })), _jsx("li", __assign({ className: 'go_top' }, { children: _jsx("a", __assign({ href: '#', className: 'n_top', onClick: this.onScrollTopClick }, { children: this.props.intl.formatMessage(messages.main_up) })) }))] })) })));
    };
    return Navigator;
}(PureComponent));
Navigator.propTypes = {
    country: PropTypes.string.isRequired,
    intl: PropTypes.object.isRequired,
};
Navigator = withRouter(Navigator);
export default injectIntl(Navigator);



// WEBPACK FOOTER //
// ./src/components/Navigator.jsx